import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from "@angular/router";
import { Location } from "@angular/common";
import { MainserviceService } from './../mainservice.service';

import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-mall-detail',
  templateUrl: './mall-detail.component.html',
  styleUrls: ['./mall-detail.component.scss']
})
export class MallDetailComponent implements OnInit {

  mall:any;


  constructor(
    private mainservice: MainserviceService,
    private route:ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit() {
    this.route.paramMap.switchMap((params :ParamMap) =>
    this.mainservice.getMall(+params.get('id')))
  .subscribe( mall => this.mall = mall)
  }

  goBack():void {
    this.location.back();
  }

}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/mall-detail/mall-detail.component.ts